import { useSearchParams } from 'react-router';
import { PageContainer } from '@/layouts/PageContainer';
import { BookingsTab } from './BookingsTab';
import { HoursTab } from './HoursTab';
import { MonthTab } from './MonthTab';
import { NoShowsTab } from './NoShowsTab';
import { WaitlistTab } from './WaitlistTab';
import styles from './calendar.module.css';

const TABS = [
  { key: 'month', label: 'Month' },
  { key: 'bookings', label: 'Bookings' },
  { key: 'waitlist', label: 'Waitlist' },
  { key: 'no-shows', label: 'No-shows & deposits' },
  { key: 'hours', label: 'Opening hours' },
] as const;
type TabKey = (typeof TABS)[number]['key'];

/**
 * Admin v2 "Calendar & bookings" (#15–#22): Month, Bookings, Waitlist,
 * No-shows & deposits and Opening hours. The tab is kept in the URL (?tab=).
 */
export function CalendarPage() {
  const [params, setParams] = useSearchParams();
  const raw = params.get('tab');
  const tab: TabKey = TABS.some((t) => t.key === raw)
    ? (raw as TabKey)
    : 'month';
  const select = (key: TabKey) => {
    const next = new URLSearchParams(params);
    next.set('tab', key);
    setParams(next);
  };
  return (
    <PageContainer>
      <div className={styles.tabs} role="tablist" aria-label="Calendar">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={tab === t.key}
            className={styles.tab}
            onClick={() => select(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div role="tabpanel" aria-label={TABS.find((t) => t.key === tab)?.label}>
        {tab === 'month' && <MonthTab />}
        {tab === 'bookings' && <BookingsTab />}
        {tab === 'waitlist' && <WaitlistTab />}
        {tab === 'no-shows' && <NoShowsTab />}
        {tab === 'hours' && <HoursTab />}
      </div>
    </PageContainer>
  );
}
